import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { googleMap } from './Map';

const SelectedDeviceMap = (props) => {
  const {onChangeCenter} = props;
  const mapCenter = useSelector(state => {
    if (state.devices.selectedId) {
      const position = state.positions.items[state.devices.selectedId] || null;
      if (position) {
        return [position.longitude, position.latitude];
      }
    }
    return null;
  });
  const selectedId = useSelector(state => {
    if (state.devices.selectedId) {
      return state.devices.selectedId;
    }
    return null;
  });
  const center = {
    lat:mapCenter&& mapCenter[1],
    lng:mapCenter && mapCenter[0],
  }

useEffect(() => {
  onChangeCenter(center);
}, [center.lat]);

  return null;
}

export default SelectedDeviceMap;
